export default "__VITE_ASSET__dCZh$lhO__"